import { Injectable } from '@angular/core';
import { ChartViewDTO } from '../model/chart_view/chart-view-dto';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
export class DashboardDepartementService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    rankingTacheEnRetard(departementid) 
    {
        return this._restClientService.load<any[]>('dashboard-departement/ranking-tache-en-retard?departementid='+departementid);
    }
    
}